
import React, { Fragment, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { eraseMissionData, navigateTo } from '../../utils/commonFunctions';
import ConfirmationDialog from './confirmation_dialog/ConfirmationDialog';

const CloseButton = () => {
    let navigate = useNavigate();
    let dispatch = useDispatch();
    const [isShowModal, setIsShowModal] = useState(false);
    const params = useParams();
    const { mission_name, mission_id } = params

    return (
        <Fragment>
            <button
                className="d-flex align-items-center btn btn-outline-danger pt-1 pb-1 pe-5 ps-4 fs-14 "
                onClick={() => {
                    setIsShowModal(true)
                }}
            >
                <i className="fe fe-x me-1 fs-16"></i>
                Close
            </button>
            <ConfirmationDialog
                type='cancel'
                open={isShowModal ? true : false}
                title={`Discard Satellite Configuration?`}
                description={`Discarding satellite configuration flow will take you back to the list of satellites.`}
                onCancel={() => setIsShowModal(false)}
                onConfirm={() => {
                    eraseMissionData(dispatch)
                    navigateTo(`${mission_name}/_details/${mission_id}/Satellites`, navigate)
                    setIsShowModal(false)
                }}
                confirm_button_text={`Discard`}
            />
        </Fragment>
    )
}

export default CloseButton